<div>
  <div>
    {{ issue.message }}
  </div>

  <!-- Scripts render before the original error: guidance first, raw error as supporting detail -->
  @if (issue.scripts && scriptLanguages.length > 0) {
    <div class="padding-top scripts-section" [class.has-tabs]="scriptLanguages.length > 1">
      @if (scriptLanguages.length > 1) {
        <app-tabs
          [tabs]="scriptTabs"
          [useRouting]="false"
          [activeTabIndex]="activeScriptTabIndex"
          (tabChange)="onScriptTabChange($event)"
        ></app-tabs>
      }
      <div class="command-block">
        <button
          class="copy-btn"
          [copy-clipboard]="activeScriptContent"
          (copied)="copyFeedback.onCopied('script-' + activeScriptLanguage)"
        >
          @if (copyFeedback.copiedStates['script-' + activeScriptLanguage]) {
            <svg lucideCheck class="copy-check"></svg>
          } @else {
            <svg lucideCopy></svg>
          }
          {{ copyFeedback.copiedStates['script-' + activeScriptLanguage] ? 'Copied' : 'Copy' }}
        </button>
        <pre><code>{{ activeScriptContent }}</code></pre>
      </div>
    </div>
  }

  @if (issue.originalErrorMessage) {
    <div class="padding-top">
      <div class="error-label">{{ originalErrorHeaderText }}</div>
      <div class="command-block">
        <button
          class="copy-btn"
          [copy-clipboard]="issue.originalErrorMessage"
          (copied)="copyFeedback.onCopied('originalError')"
        >
          @if (copyFeedback.copiedStates['originalError']) {
            <svg lucideCheck class="copy-check"></svg>
          } @else {
            <svg lucideCopy></svg>
          }
          {{ copyFeedback.copiedStates['originalError'] ? 'Copied' : 'Copy' }}
        </button>
        <pre><code>{{ issue.originalErrorMessage }}</code></pre>
      </div>
    </div>
  }

  @if (issue.promptToUpdateTemplates) {
    <div class="padding-top">
      <a href="" (click)="showAccessDialog($event)">Click here to update your access templates</a>
    </div>
  }

  @if (issue.additionalDetailsUrl && issue.additionalDetailsTitle) {
    <div class="padding-top">
      <a [href]="issue.additionalDetailsUrl" target="_blank">
        {{ issue.additionalDetailsTitle }}
      </a>
    </div>
  }
</div>

<modal-dialog #updateAccessDialog [dialogTemplate]="updateAccessDialogTemplate"></modal-dialog>

<ng-template #updateAccessDialogTemplate>
  <update-access-dialog
    [applicationType]="applicationType"
    [sourceEndpointUri]="sourceEndpointUri"
    [targetEndpointUri]="targetEndpointUri"
    [identityProviderId]="identityProviderId"
    (done)="dismissAccessDialog()"
    (cancel)="dismissAccessDialog()"
  ></update-access-dialog>
</ng-template>
